import { AssetMessageUpdate } from "~/types/message";

export const addUpdateToTracker = (tracker: any, update: AssetMessageUpdate) => {
  const { type, data } = update;
  if (type === "update") {
    const { id, title, content, is_final } = data as { id: string; title: string; content: string; is_final: boolean };
    if (tracker[id]) {
      tracker[id].content += content;
      tracker[id].title = title;
      tracker[id].is_final = tracker[id].is_final || is_final;
    } else {
      tracker[id] = {
        id,
        title,
        content,
        is_final
      }
    }
  }
};
